import Vue from 'vue'
import VueRouter from 'vue-router'
import PHome from '../views/PHome.vue'
import PRHome from '../views/PRHome.vue'
import LHome from '../views/LHome.vue'
import MHome from '../views/MHome.vue'
import MRHome from '../views/MRHome.vue'
import GJHome from '../views/GJHome.vue'
import MGJHome from '../views/MGJHome.vue'
import MLiveHome from '../views/MLiveHome.vue'
import TalentHome from '../views/TalentHome.vue'
import MTalentHome from '../views/MTalentHome.vue'
import HdHome from '../views/HdHome.vue'
import ApplyActivity from './applyActivity.js'
import Sign from './sign.js'

// 重写路由的push方法
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error=> error)
}
Vue.use(VueRouter)

const routes = [
    //课程首页
    // {
    //    path: '/',
    //    name: 'PHome',
    //    component: PRHome,
    //    redirect: '/pindex',
    // },
    //报告首页
    // {
    //     path: '/',
    //     name: 'PRHome',
    //     component: PRHome,
    //     redirect: '/reportindex',
    // },
    //股鲸首页
    // {
    //     path: '/',
    //     name: 'GJHome',
    //     component: GJHome,
    //     redirect: '/gjindex',
    // },
    //直播首页
    // {
    //     path: '/',
    //     name: 'LHome',
    //     component: LHome,
    //     redirect: '/liveingindex',
    // },
    //猎聘首页
    {
        path: '/',
        name: 'TalentHome',
        component: TalentHome,
        redirect: '/talentIndex',
    },
    //活动首页
    //  {
    //      path: '/',
    //      name: 'HdHome',
    //      component: HdHome,
    //      redirect: '/hdIndex',
    //  },
    {
        path: '/pindex',
        name: 'PHome',
        component: PHome,
        redirect: '/pindex',
        children: [
            {
                path: '/pindex',
                component: () => import(`@/views/pc/index/Index.vue`),
                name: 'Index'
            },
            {
                path: '/ke/MediaMatrix',
                component: () => import(`@/views/pc/index/MediaMatrix.vue`),
                name: 'MediaMatrix1'
            },
            {
                path: '/about',
                name: 'About',
                component: () => import('@/views/pc/about/About.vue')
            },
            {
                path: '/search',
                name: 'Search',
                component: () => import(`@/views/pc/search/Search.vue`),
            },
            {
                path: '/questionsearch',
                name: 'QuestionSearch',
                component: () => import(`@/views/pc/search/QuestionSearch.vue`),
            },
            {
                path: '/study',
                name: 'Study',
                component: () => import(`@/views/pc/study/Study.vue`),
            },
            {
                path: '/order',
                name: 'OrderIndex',
                component: () => import(`@/views/pc/order/OrderIndex.vue`),
            },
            {
                path: '/orderbr',
                name: 'BuyResult',
                component: () => import(`@/views/pc/order/BuyResult.vue`),
            },
            {
                path: '/organ',
                name: 'OrganIndex',
                component: () => import(`@/views/pc/organ/OrganIndex.vue`),
            },
            {
              path: '/teacher',
              name: 'TeacherIndex',
              component: () => import(`@/views/pc/organ/TeacherIndex.vue`),
            },
            {
              path: '/coursedetails',
              name: 'CourseDetails',
              component: () => import(`@/views/pc/courseDetails/CourseDetails.vue`),
            },
            {
                path: '/questionDetails',
                name: 'QuestionDetails',
                component: () => import(`@/views/pc/questionDetails/QuestionDetails.vue`),
            },
            {
                path: '/memberDetails',
                name: 'MemberDetails',
                component: () => import(`@/views/pc/memberDetails/memberDetails.vue`),
            },
            {
                path: '/personalCenter',
                name: 'PersonalCenter',
                component: () => import(`@/views/pc/personalCenter/PersonalCenter.vue`),
                redirect: '/personalCenter/StartTopic',
                children: [
                    {
                        path: '/personalCenter/ClassScheduleCard',
                        name: 'ClassScheduleCard',
                        component: () => import(`@/views/pc/personalCenter/subPage/ClassScheduleCard.vue`),
                    },
                    {
                        path: '/personalCenter/AllCourses',
                        name: 'AllCourses',
                        component: () => import(`@/views/pc/personalCenter/subPage/AllCourses.vue`),
                    },
                    {
                        path: '/personalCenter/ClassScheduleCard',
                        name: 'ClassScheduleCard',
                        component: () => import(`@/views/pc/personalCenter/subPage/ClassScheduleCard.vue`),
                    },
                    {
                        path: '/personalCenter/UpdatePassword',
                        name: 'UpdatePassword',
                        component: () => import(`@/views/pc/personalCenter/subPage/UpdatePassword.vue`),
                    },
                    {
                        path: '/personalCenter/Info',
                        name: 'Info',
                        component: () => import(`@/views/pc/personalCenter/subPage/Info.vue`),
                    },
                    {
                        path: '/personalCenter/MyCollection',
                        name: 'MyCollection',
                        component: () => import(`@/views/pc/personalCenter/subPage/MyCollection.vue`),
                    },
                    {
                        path: '/personalCenter/MyConcern',
                        name: 'MyConcern',
                        component: () => import(`@/views/pc/personalCenter/subPage/MyConcern.vue`),
                    },
                    {
                        path: '/personalCenter/MyOrder',
                        name: 'MyOrder',
                        component: () => import(`@/views/pc/personalCenter/subPage/MyOrder.vue`),
                    },
                    {
                        path: '/personalCenter/HdTicket',
                        name: 'HdTicket',
                        component: () => import(`@/views/pc/personalCenter/subPage/HdTicket.vue`),
                    },
                    {
                        path: '/personalCenter/AllItemBank',
                        name: 'AllItemBank',
                        component: () => import(`@/views/pc/personalCenter/subPage/AllItemBank.vue`)
                    },
                    {
                        path: '/personalCenter/DoRecord',
                        name: 'DoRecord',
                        component: () => import(`@/views/pc/personalCenter/subPage/DoRecord.vue`)
                    },
                    // 个人中心-简历管理
                    {
                        path: '/personalCenter/Resume',
                        name: 'Resume',
                        component: () => import(`@/views/pc/personalCenter/subPage/Resume.vue`)
                    },
                    {
                        path: '/personalCenter/StartTopic',
                        name: 'StartTopic',
                        component: () => import(`@/views/pc/personalCenter/subPage/StartTheTopic.vue`)
                    },
                    {
                        path: '/personalCenter/MyQuBank',
                        name: 'MyQuBank',
                        component: () => import(`@/views/pc/personalCenter/subPage/MyQuestionBank.vue`)
                    },
                    {
                        path: '/personalCenter/MyAchievement',
                        name: 'MyAchievement',
                        component: () => import(`@/views/pc/personalCenter/subPage/MyAchievement.vue`)
                    },
                    {
                        path: '/personalCenter/MyCoupon',
                        name: 'MyCoupon',
                        meta: {'title': '优惠券', 'keepAlive': true},
                        component: () => import(`@/views/pc/personalCenter/subPage/MyCoupon.vue`),
                    },
                    {
                        path: '/personalCenter/ExchangeCenter',
                        name: 'ExchangeCenter',
                        meta: {'title': '兑换中心', 'keepAlive': true},
                        component: () => import(`@/views/pc/personalCenter/subPage/ExchangeCenter.vue`),
                    }
                ]
            },
            {
                path: '/testPaper',
                name: 'TestPaper',
                component: () => import(`@/views/pc/testPaper/testPaper.vue`),
                redirect: '/p/testPaper',
                children: [
                    {
                        path: '/testPaper/examinationPaperInformation',
                        name: 'ExaminationPaperInformation',
                        component: () => import(`@/views/pc/testPaper/subPage/examinationPaperInformation.vue`)
                    },
                    {
                        path: '/testPaper/examinationInterface',
                        name: 'ExaminationInterface',
                        component: () => import(`@/views/pc/testPaper/subPage/examinationInterface.vue`)
                    },
                    {
                        path: '/testPaper/viewingResults',
                        name: 'ViewingResults',
                        component: () => import(`@/views/pc/testPaper/subPage/viewingResults.vue`)
                    }
                ]
            },
            {
                path: '/jjcy',
                name: 'Jjcy',
                component: () => import(`@/views/pc/specialPage/fundsFromIndex.vue`)
            },
            {
                path: '/fundsFromSub',
                component: () => import('@/views/pc/specialPage/fundsFrom.vue'),
                children: [
                    {
                        path: '/messageDetails',
                        name: 'FundsFromDetails',
                        component: () => import(`@/views/pc/specialPage/fundsFrom/fundsFromDetails.vue`)
                    },
                    {
                        path: '/messageList',
                        name: 'MessageList',
                        component: () => import(`@/views/pc/specialPage/fundsFrom/messageList.vue`)
                    }
                ]
            }
        ]
    },
    {
        path: '/m',
        name: 'MHome',
        component: MHome,
        redirect: '/m/mindex',
        children: [
            {
                path: '/m/error504',
                name: 'MError504',
                meta: {'title': '504', 'keepAlive': false},
                component: () => import(`@/views/mobile/errorPage/Error504.vue`),
            },
            {
                path: '/m/login',
                name: 'MLogin',
                meta: {'title': '登录', 'keepAlive': false},
                component: () => import(`@/views/mobile/login/MLogin.vue`),
            },
            {
                path: '/m/register',
                name: 'MRegister',
                meta: {'title': '注册', 'keepAlive': true},
                component: () => import(`@/views/mobile/login/MRegister.vue`),
            },
            {
                path: '/m/resetPwd',
                name: 'MResetPwd',
                meta: {'title': '忘记密码', 'keepAlive': true},
                component: () => import(`@/views/mobile/login/MResetPwd.vue`),
            },
            {
                path: '/m/mindex',
                name: 'MIndex',
                meta: {'title': '首页', 'keepAlive': true},
                component: () => import(`@/views/mobile/index/MIndex.vue`),
            },
            {
                path: '/m/my',
                name: 'MMy',
                meta: {'title': '我的', 'keepAlive': true},
                component: () => import(`@/views/mobile/my/MMy.vue`),
                redirect: '/m/me',
                children: [
                    {
                        path: '/m/me',
                        name: 'Mme',
                        meta: {'title': '我的', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/me/Mme.vue`),
                    },
                    {
                        path: '/m/orderList',
                        name: 'MOrderList',
                        meta: {'title': '订单列表', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/order/MOrderList.vue`),
                    },
                    {
                        path: '/m/orderView',
                        name: 'MOrderView',
                        meta: {'title': '订单详细', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/order/MOrderView.vue`),
                    },
                    {
                        path: '/m/confirmOrder',
                        name: 'MConfirmOrder',
                        meta: {'title': '确认订单', 'keepAlive': false},
                        component: () => import(`@/views/mobile/my/order/MConfirmOrder.vue`),
                    },
                    {
                        path: '/m/payResult',
                        name: 'MPayResult',
                        meta: {'title': '支付结果', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/order/MPayResult.vue`),
                    },
                    {
                        path: '/m/myCourse',
                        name: 'MMyCourse',
                        meta: {'title': '我的课程', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/course/MMyCourse.vue`),
                    },
                    {
                        path: '/m/myQuestion',
                        name: 'MMyQuestion',
                        meta: {'title': '我的题库', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/question/MMyQuestion.vue`),
                    },
                    {
                        path: '/m/myQueBank',
                        name: 'MMyQueBank',
                        meta: {'title': '我的题库', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/question/myQueBank.vue`),
                    },
                    {
                        path: '/m/myExam',
                        name: 'MMyExam',
                        meta: {'title': '我的考试', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/myExam/MMyExam.vue`),
                    },
                    {
                        path: '/m/mresume',
                        name: 'MResume',
                        meta: {'title': '简历管理', 'keepAlive': false},
                        component: () => import(`@/views/mobile/my/resume/MResume.vue`),
                    },
                    {
                        path: '/m/mresumeDetails',
                        name: 'MResumeDetails',
                        meta: {'title': '简历详情', 'keepAlive': false},
                        component: () => import(`@/views/mobile/my/resume/MResumeDetails.vue`),
                    },
                    {
                        path: '/m/mBaseInfo',
                        name: 'BaseInfo',
                        meta: {'title': '简历基本信息', 'keepAlive': false},
                        component: () => import(`@/views/mobile/my/resume/subPage/BaseInfo.vue`),
                    },
                    {
                        path: '/m/mJobIntension',
                        name: 'JobIntension',
                        meta: {'title': '简历求职意向', 'keepAlive': false},
                        component: () => import(`@/views/mobile/my/resume/subPage/JobIntension.vue`),
                    },
                    {
                        path: '/m/mWorkHistory',
                        name: 'WorkHistory',
                        meta: {'title': '简历工作经历', 'keepAlive': false},
                        component: () => import(`@/views/mobile/my/resume/subPage/WorkHistory.vue`),
                    },
                    {
                        path: '/m/mProjectExperience',
                        name: 'ProjectExperience',
                        meta: {'title': '简历项目经历', 'keepAlive': false},
                        component: () => import(`@/views/mobile/my/resume/subPage/ProjectExperience.vue`),
                    },
                    {

                        path: '/m/mEduExperience',
                        name: 'EduExperience',
                        meta: {'title': '简历教育经历', 'keepAlive': false},
                        component: () => import(`@/views/mobile/my/resume/subPage/EduExperience.vue`),
                    },
                    {
                        path: '/m/mSelfEvaluation',
                        name: 'SelfEvaluation',
                        meta: {'title': '简历自我评价', 'keepAlive': false},
                        component: () => import(`@/views/mobile/my/resume/subPage/SelfEvaluation.vue`),
                    },
                    {
                        path: '/m/myFavorite',
                        name: 'MMyFavorite',
                        meta: {'title': '我的收藏', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/favorite/MMyFavorite.vue`),
                    },
                    {
                        path: '/m/wallet',
                        name: 'MMyWallet',
                        meta: {'title': '我的钱包', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/wallet/MMyWallet.vue`),
                    },
                    {
                        path: '/m/follow',
                        name: 'MMyFollow',
                        meta: {'title': '我的钱包', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/follow/MMyFollow.vue`),
                    },
                    {
                        path: '/m/achievement',
                        name: 'MMyachievement',
                        meta: {'title': '我的成就', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/achievement/MMyachievement.vue`),
                    },
                    {
                        path: '/m/coupon',
                        name: 'MMyCoupon',
                        meta: {'title': '优惠券', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/myCoupon/MMyCoupon.vue`),
                    },
                    {
                        path: '/m/exchange',
                        name: 'MMyExchange',
                        meta: {'title': '兑换中心', 'keepAlive': false},
                        component: () => import(`@/views/mobile/my/myExchange/MMyExchange.vue`),
                    },
                    {
                        path: '/m/exchangeMsg',
                        name: 'ExchangeMsg',
                        meta: {'title': '兑换信息', 'keepAlive': false},
                        component: () => import(`@/views/mobile/my/myExchange/ExchangeMsg.vue`),
                    },
                    {
                        path: '/m/userinfo',
                        name: 'UserInfo',
                        meta: {'title': '个人信息', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/userinfo/UserInfo.vue`),
                    },
                    {
                        path: '/m/naire',
                        name: 'Questionnaire',
                        meta: {'title': '问卷', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/quesnaire/Questionnaire.vue`),
                    }
                ]
            },
            {
                path: '/m/sort',
                name: 'MSort',
                meta: {'title': '分类', 'keepAlive': true},
                redirect: '/m/categoryList',
                component: () => import(`@/views/mobile/sort/MSort.vue`),
                children: [
                    {
                        path: '/m/categoryList',
                        name: 'MCategoryList',
                        meta: {'title': '分类', 'keepAlive': true},
                        component: () => import(`@/views/mobile/sort/category/MCategoryList.vue`),
                    },
                    {
                        path: '/m/searchList',
                        name: 'MSearchList',
                        meta: {'title': '分类', 'keepAlive': true},
                        component: () => import(`@/views/mobile/sort/searchList/MSearchList.vue`),
                    },
                    {
                        path: '/m/agencyView',
                        name: 'MAgencyView',
                        meta: {'title': '机构详细', 'keepAlive': true},
                        component: () => import(`@/views/mobile/sort/agency/MAgencyView.vue`),
                    },
                    {
                        path: '/m/teacherView',
                        name: 'MTeacherView',
                        meta: {'title': '老师详细', 'keepAlive': true},
                        component: () => import(`@/views/mobile/sort/agency/MTeacherView.vue`),
                    },
                    {
                        path: '/m/courseView',
                        name: 'MCourseView',
                        meta: {'title': '课程详细', 'keepAlive': true},
                        // meta: {'title': '课程详细'},
                        component: () => import(`@/views/mobile/sort/course/MCourseView.vue`),
                    },
                    {
                        path: '/m/courseReportPrview',
                        name: 'MCourseReportPrview',
                        meta: {'title': '报告预览', 'keepAlive': true},
                        component: () => import(`@/views/mobile/sort/course/MCourseReportPrview.vue`),
                    },
                    {
                        path: '/m/evaluationView',
                        name: 'MCourseEvaluation',
                        meta: {'title': '课程评价', 'keepAlive': true},
                        // meta: {'title': '课程评价'},
                        component: () => import(`@/views/mobile/sort/course/MCourseEvaluation.vue`),
                    },
                ]
            },
            {
                path: '/m/examView',
                name: 'MExamView',
                meta: {'title': '考试', 'keepAlive': true},
                component: () => import(`@/views/mobile/exam/MExamView.vue`),
            },
            {
                path: '/m/examResult',
                name: 'MExamResult',
                meta: {'title': '考试结果', 'keepAlive': true},
                component: () => import(`@/views/mobile/exam/MExamResult.vue`),
            },
            {
                path: '/m/answerKeys',
                name: 'AnswerKeys',
                meta: {'title': '答案解析', 'keepAlive': true},
                component: () => import(`@/views/mobile/exam/AnswerKeys.vue`),
            },
            {
                path: '/m/paperDetails',
                name: 'PaperDetails',
                meta: {'title': '试卷详情', 'keepAlive': true},
                component: () => import(`@/views/mobile/testPaper/PaperDetails.vue`),
            },
            {
                path: '/m/paperInfo',
                name: 'PaperInfo',
                meta: {'title': '试卷信息', 'keepAlive': true},
                component: () => import(`@/views/mobile/testPaper/PaperInfo.vue`),
            },
            {
                path: '/m/ques/question',
                name: 'QuestionList',
                meta: {'title': '专题列表', 'keepAlive': false},
                component: () => import(`@/views/mobile/question/QuestionList.vue`),
            },
            {
                path: '/m/ques/qbList',
                name: 'QbList',
                meta: {'title': '题库列表', 'keepAlive': true},
                component: () => import(`@/views/mobile/question/qbList.vue`),
            },
            {
                path: '/m/diary/diaryInfo',
                name: 'DynamicStateDetails',
                meta: {'title': '动态详情', 'keepAlive': false},
                component: () => import(`@/views/mobile/app/dynamicStateDetails.vue`)
            },
            {
                path: '/m/diary/topicInfo',
                name: 'TopicDetails',
                meta: {'title': '话题详情', 'keepAlive': false},
                component: () => import(`@/views/mobile/app/topicDetails.vue`)
            },
            {
                path: '/m/memberDetails',
                name: 'MMemberDetails',
                meta: {'title': '会员详情', 'keepAlive': false},
                component: () => import(`@/views/mobile/memberDetails/memberDetails.vue`),
            },
        ]
    },
    {
        path: '/reporthome',
        name: 'PRHome',
        component: PRHome,
        redirect: '/reportindex',
        children: [
            {
                path: '/reportindex',
                component: () => import(`@/views/reportPc/reportindex/ReportIndex.vue`),
                name: 'ReportIndex'
            },
            {
                path: '/report/mediamatrix',
                component: () => import(`@/views/reportPc/reportindex/MediaMatrix.vue`),
                name: 'MediaMatrix2'
            },
            {
                path: '/reportdetails',
                component: () => import(`@/views/reportPc/reportdetail/ReportDetails.vue`),
                name: 'ReportDetails'
            },
            {
                path: '/reportpreview',
                component: () => import(`@/views/reportPc/reportdetail/ReportPreview.vue`),
                name: 'ReportPreview'
            },
            {
                path: '/reportsearch',
                component: () => import(`@/views/reportPc/reportsearch/ReportSearch.vue`),
                name: 'ReportSearch'
            },
            {
                path: '/allsearch',
                name: 'AllSearch',
                component: () => import(`@/views/pc/search/AllSearch.vue`),
            },
        ]
    },
    {
        path: '/m/mreporthome',
        name: 'MRHome',
        component: MRHome,
        redirect: '/m/mreportindex',
        children: [
            {
                path: '/m/mreportindex',
                name: 'MReportIndex',
                meta: {'title': '报告首页', 'keepAlive': true},
                component: () => import(`@/views/reportMobile/index/MReportIndex.vue`),
            },
            {
                path: '/m/mreportdetails',
                name: 'MReportDetails',
                meta: {'title': '报告详情', 'keepAlive': true},
                component: () => import(`@/views/reportMobile/details/MReportDetails.vue`),
            },
            {
                path: '/m/mreportPreview',
                name: 'MReportPreview',
                meta: {'title': '报告预览', 'keepAlive': true},
                component: () => import(`@/views/reportMobile/details/MReportPreview.vue`),
            },
            {
                path: '/m/mreportSearch',
                name: 'MReportSearch',
                meta: {'title': '搜索', 'keepAlive': true},
                component: () => import(`@/views/reportMobile/search/MReportSearch.vue`),
            },
            {
                path: '/m/my',
                name: 'MMy',
                meta: {'title': '我的', 'keepAlive': true},
                component: () => import(`@/views/mobile/my/MMy.vue`),
                redirect: '/m/me2',
                children: [
                    {
                        path: '/m/me2',
                        name: 'Mme2',
                        meta: {'title': '我的', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/me/Mme.vue`),
                    },
                    {
                        path: '/m/orderList',
                        name: 'MOrderList',
                        meta: {'title': '订单列表', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/order/MOrderList.vue`),
                    },
                    {
                        path: '/m/orderView',
                        name: 'MOrderView',
                        meta: {'title': '订单详细', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/order/MOrderView.vue`),
                    },
                    {
                        path: '/m/confirmOrder',
                        name: 'MConfirmOrder',
                        meta: {'title': '确认订单', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/order/MConfirmOrder.vue`),
                    },
                    {
                        path: '/m/payResult',
                        name: 'MPayResult',
                        meta: {'title': '支付结果', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/order/MPayResult.vue`),
                    },
                    {
                        path: '/m/myCourse',
                        name: 'MMyCourse',
                        meta: {'title': '我的课程', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/course/MMyCourse.vue`),
                    },
                    {
                        path: '/m/myQuestion',
                        name: 'MMyQuestion',
                        meta: {'title': '我的题库', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/question/MMyQuestion.vue`),
                    },
                    {
                        path: '/m/myExam',
                        name: 'MMyExam',
                        meta: {'title': '我的考试', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/myExam/MMyExam.vue`),
                    },
                    {
                        path: '/m/myFavorite',
                        name: 'MMyFavorite',
                        meta: {'title': '我的收藏', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/favorite/MMyFavorite.vue`),
                    },
                    {
                        path: '/m/wallet',
                        name: 'MMyWallet',
                        meta: {'title': '我的钱包', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/wallet/MMyWallet.vue`),
                    },
                    {
                        path: '/m/follow',
                        name: 'MMyFollow',
                        meta: {'title': '我的钱包', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/follow/MMyFollow.vue`),
                    },
                ]
            },
            {
                path: '/m/reportsort',
                name: 'MReportSort',
                meta: {'title': '分类', 'keepAlive': true},
                redirect: '/m/reportCategoryList',
                component: () => import(`@/views/reportMobile/sort/MReportSort.vue`),
                children: [
                    {
                        path: '/m/reportCategoryList',
                        name: 'MReportCategoryList',
                        meta: {'title': '分类', 'keepAlive': true},
                        component: () => import(`@/views/reportMobile/sort/category/MReportCategoryList.vue`),
                    }
                ]
            }
        ]
    },
    {
        path: '/gjhome',
        name: 'GJHome',
        component: GJHome,
        redirect: '/gjindex',
        children: [
            {
                path: '/gjindex',
                component: () => import(`@/views/gujing/index/GJIndex.vue`),
                name: 'GJIndex'
            },
            {
                path: '/enterpriseestimation',
                component: () => import(`@/views/gujing/equityTool/EnterpriseEstimation.vue`),
                name: 'EnterpriseEstimation'
            },
            {
                path: '/estimationstep',
                component: () => import(`@/views/gujing/equityTool/EstimationStep.vue`),
                name: 'EstimationStep'
            },
            {
                path: '/excitation',
                component: () => import(`@/views/gujing/excitationTool/Excitation.vue`),
                name: 'Excitation'
            },
            {
                path: '/excitationstep',
                component: () => import(`@/views/gujing/excitationTool/ExcitationStep.vue`),
                name: 'ExcitationStep'
            },
            {
                path: '/selectexcitation',
                component: () => import(`@/views/gujing/excitationTool/SelectExcitation.vue`),
                name: 'SelectExcitation'
            },
            {
                path: '/equitylearning',
                component: () => import(`@/views/gujing/EquityLearningTool/EquityLearning.vue`),
                name: 'EquityLearning'
            },
            {
                path: '/individualization',
                component: () => import(`@/views/gujing/individualization/individualization.vue`),
                name: 'Individualization'
            },
            {
                path: '/gjinfo',
                component: () => import(`@/views/gujing/PersonalCenter/Info.vue`),
                name: 'GJInfo'
            },
            {
                path: '/gjupdatepassword',
                component: () => import(`@/views/gujing/PersonalCenter/UpdatePassword.vue`),
                name: 'GJUpdatePassword'
            },
            {
                path: '/gjmyreport',
                component: () => import(`@/views/gujing/PersonalCenter/MyReport.vue`),
                name: 'GJMyReport'
            }
        ]
    },
    {
        path: '/m/gjhome',
        name: 'MGJHome',
        component: MGJHome,
        redirect: '/m/mgjindex',
        children: [
            {
                path: '/m/mgjindex',
                name: 'GJMIndex',
                meta: {'title': '首页', 'keepAlive': false},
                component: () => import(`@/views/gjMobile/index/GJMIndex.vue`)
            },
            {
                path: '/m/mEnterpriseEstimation',
                name: 'MEnterpriseEstimation',
                meta: {'title': '企业估值', 'keepAlive': false},
                component: () => import(`@/views/gjMobile/mEquityTool/MEnterpriseEstimation.vue`)
            },
            {
                path: '/m/mEstimationStep',
                name: 'MEstimationStep',
                meta: {'title': '估值流程', 'keepAlive': false},
                component: () => import(`@/views/gjMobile/mEquityTool/MEstimationStep.vue`)
            },
            {
                path: '/m/mExcitation',
                name: 'MExcitation',
                meta: {'title': '股权激励', 'keepAlive': false},
                component: () => import(`@/views/gjMobile/mExcitationTool/MExcitation.vue`)
            },
            {
                path: '/m/mStimulateStep',
                name: 'MStimulateStep',
                meta: {'title': '股权激励流程', 'keepAlive': false},
                component: () => import(`@/views/gjMobile/mExcitationTool/MStimulateStep.vue`)
            },
            {
                path: '/m/mLookReport',
                name: 'MLookReport',
                meta: {'title': '查看报告', 'keepAlive': false},
                component: () => import(`@/views/gjMobile/mExcitationTool/MLookReport.vue`)
            },
            {
                path: '/m/mDownloadReport',
                name: 'MDownloadReport',
                meta: {'title': '下载报告', 'keepAlive': false},
                component: () => import(`@/views/gjMobile/mExcitationTool/MDownloadReport.vue`)
            },
            {
                path: '/m/mIndividualization',
                name: 'MIndividualization',
                meta: {'title': '定制服务', 'keepAlive': false},
                component: () => import(`@/views/gjMobile/mindividualization/mIndividualization.vue`)
            },
            {
                path: '/m/mEquityLearning',
                name: 'MEquityLearning',
                meta: {'title': '股权学习', 'keepAlive': false},
                component: () => import(`@/views/gjMobile/mEquityLearningTool/MEquityLearning.vue`)
            },
            {
                path: '/m/msg',
                name: 'Msg',
                meta: {'title': '留言咨询', 'keepAlive': false},
                component: () => import(`@/views/gjMobile/message/Msg.vue`)
            },
            {
                path: '/m/mgjMy',
                name: 'My',
                meta: {'title': '个人中心', 'keepAlive': false},
                component: () => import(`@/views/gjMobile/my/My.vue`)
            },
            {
                path: '/m/compValue',
                name: 'CompValue',
                meta: {'title': '我的企业估值', 'keepAlive': false},
                component: () => import(`@/views/gjMobile/my/CompValue.vue`)
            },
            {
                path: '/m/createReport',
                name: 'CreateReport',
                meta: {'title': '获取企业估值报告', 'keepAlive': false},
                component: () => import(`@/views/gjMobile/my/CreateReport.vue`)
            },
            {
                path: '/m/equity',
                name: 'Equity',
                meta: {'title': '我的股权激励', 'keepAlive': false},
                component: () => import(`@/views/gjMobile/my/Equity.vue`)
            },
        ]
    },
    {
        path: '/m/mlivehome',
        name: 'MLiveHome',
        component: MLiveHome,
        redirect: '/m/mliveindex',
        children: [
            {
                path: '/m/mliveindex',
                name: 'MLiveIndex',
                meta: {'title': '移动端直播首页', 'keepAlive': true},
                component: () => import(`@/views/Mlive/index/MLiveIndex.vue`)
            },
            {
                path: '/m/mmorelive',
                name: 'MMorelive',
                meta: {'title': '更多直播', 'keepAlive': false},
                component: () => import(`@/views/Mlive/index/MMorelive.vue`)
            },
            {
                path: '/m/livevideo',
                name: 'MlivingVideoList',
                meta: {'title': '财经投资', 'keepAlive': false},
                component: () => import(`@/views/Mlive/livingVideo/MlivingVideoList.vue`)
            },
            {
                path: '/m/livevideoview',
                name: 'MlivingVideoView',
                meta: {'title': '视频详情', 'keepAlive': false},
                component: () => import(`@/views/Mlive/livingVideo/MlivingVideoView.vue`)
            },
            {
                path: '/m/mlivesearch',
                name: 'MSearchPage',
                meta: {'title': '搜索列表', 'keepAlive': false},
                component: () => import(`@/views/Mlive/index/MSearchPage.vue`)
            },
            {
                path: '/m/mliveDetails',
                name: 'MliveDetails',
                meta: {'title': '移动端直播详情', 'keepAlive': false},
                component: () => import(`@/views/Mlive/livedetails/MliveDetails.vue`)
            },
            {
                path: '/m/mliveposter',
                name: 'MLivePoster',
                meta: {'title': '海报', 'keepAlive': false},
                component: () => import(`@/views/Mlive/livedetails/LivePoster.vue`)
            },
            {
                path: '/m/mImglive',
                name: 'MImglive',
                meta: {'title': '移动端图文直播', 'keepAlive': false},
                component: () => import(`@/views/Mlive/livedetails/MImglive.vue`)
            },
            {
                path: '/m/mImgLivePoster',
                name: 'ImgLivePoster',
                meta: {'title': '图文直播海报', 'keepAlive': false},
                component: () => import(`@/views/Mlive/livedetails/ImgLivePoster.vue`)
            },
            {
                path: '/m/my',
                name: 'MMy',
                meta: {'title': '我的', 'keepAlive': true},
                component: () => import(`@/views/mobile/my/MMy.vue`),
                redirect: '/m/me3',
                children: [
                    {
                        path: '/m/me3',
                        name: 'Mme3',
                        meta: {'title': '我的', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/me/Mme.vue`),
                    }
                ]
            }
        ]
    },
    {
        path: '/liveinghome',
        name: 'LHome',
        component: LHome,
        redirect: '/liveingindex',
        children: [
            {
                path: '/liveingindex',
                component: () => import(`@/views/liveingPc/liveingindex/LiveingIndex.vue`),
                name: 'LiveingIndex'
            },
            {
                path: '/liveingvideo',
                component: () => import(`@/views/liveingPc/liveingVideo/livingVideoList.vue`),
                name: 'livingVideoList'
            },
            {
                path: '/liveingvideoview',
                component: () => import(`@/views/liveingPc/liveingVideo/livingVideoView.vue`),
                name: 'livingVideoView'
            },
            {
                path: '/liveingdetails',
                component: () => import(`@/views/liveingPc/liveingdetails/LiveingDetails.vue`),
                name: 'LiveingDetails'
            },
            {
                path: '/videoliveing',
                component: () => import(`@/views/liveingPc/videoLiveing/videoLiveing.vue`),
                name: 'VideoLiveing'
            },
            {
                path: '/liveingsearch',
                component: () => import(`@/views/liveingPc/liveingsearch/LiveingSearch.vue`),
                name: 'LiveingSearch'
            }
        ]
    },
    {
        path: '/talenthome',
        name: 'TalentHome',
        component: TalentHome,
        redirect: '/talentIndex',
        children: [
            {
                path: '/talentIndex',
                component: () => import(`@/views/talent/index/TalentIndex.vue`),
                name: 'TalentIndex'
            },
            {
                path: '/ResumePreview',
                component: () => import(`@/views/talent/index/ResumePreview.vue`),
                name: 'ResumePreview'
            },
            {
                path: '/talentSearch',
                component: () => import(`@/views/talent/search/TalentSearch.vue`),
                name: 'TalentSearch'
            },
            {
                path: '/jobinfo',
                component: () => import(`@/views/talent/job/JobInfo.vue`),
                name: 'JobInfo'
            }
        ]
    },
    {
        path: '/m/mtalenthome',
        name: 'MTalentHome',
        component: MTalentHome,
        redirect: '/m/mtalentindex',
        children: [
            {
                path: '/m/mtalentindex',
                name: 'MTalentIndex',
                meta: {'title': '人才猎聘移动端首页', 'keepAlive': true},
                component: () => import(`@/views/mtalent/index/MTalentIndex.vue`)
            },
            {
                path: '/m/mtalentsearch',
                name: 'MTalentSearch',
                meta: {'title': '人才猎聘移动端搜索页', 'keepAlive': false},
                component: () => import(`@/views/mtalent/index/MTalentSearch.vue`)
            },
            {
                path: '/m/mJobInfo',
                name: 'MJobInfo',
                meta: {'title': '人才猎聘移动端岗位详情页', 'keepAlive': false},
                component: () => import(`@/views/mtalent/job/MJobInfo.vue`)
            },
            {
                path: '/m/mresumePreview',
                name: 'MResumePreview',
                meta: {'title': '人才猎聘移动端简历预览', 'keepAlive': false},
                component: () => import(`@/views/mtalent/job/MResumePreview.vue`)
            },
            {
                path: '/m/my',
                name: 'MMy',
                meta: {'title': '我的', 'keepAlive': true},
                component: () => import(`@/views/mobile/my/MMy.vue`),
                redirect: '/m/me3',
                children: [
                    {
                        path: '/m/me4',
                        name: 'Mme4',
                        meta: {'title': '我的', 'keepAlive': true},
                        component: () => import(`@/views/mobile/my/me/Mme.vue`),
                    }
                ]
            }
        ]
    },
    {
        path: '/hdHome',
        name: 'HdHome',
        component: HdHome,
        redirect: '/hdIndex',
        children: [
            {
                path: '/hdIndex',
                component: () => import(`@/views/hdPc/index/HdIndex.vue`),
                name: 'HdIndex'
            },{
                path: '/hdDet',
                component: () => import(`@/views/hdPc/details/HdDetails.vue`),
                name: 'HdDetails'
            },{
                path: '/sign',
                component: () => import(`@/views/hdPc/details/SignForm.vue`),
                name: 'SignForm'
            },{
                path: '/signResult',
                component: () => import(`@/views/hdPc/details/SignResult.vue`),
                name: 'SignResult'
            },{
                path: '/hdHost',
                component: () => import(`@/views/hdPc/sponsor/HdHost.vue`),
                name: 'HdHost'
            },{
                path: '/hdSearch',
                component: () => import(`@/views/hdPc/search/HdSearch.vue`),
                name: 'HdSearch'
            }
        ]
    },
    ...ApplyActivity,
    ...Sign
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
